// Module
var code = "<div class=\"scheduling-icons\" ng-class=\"{'scheduled':vm.group.isScheduled||vm.group.isIndirectlyScheduled||vm.isDetails}\"> <i class=\"fa fa-fw inactive\" title=\"{{item.title|translate}}\" ng-class=\"item.classed\" ng-repeat=\"item in vm.mapped\"></i> </div>";
// Exports
module.exports = code;